import { isEmpty } from 'lodash';

import { querystringToObj } from '@zapier/url-utils';
import { ClickIds } from '@zapier/toolbox-tracking';

import TrackingCookies from '../TrackingCookies';
import { TrackingMiddleware } from '../types';

const attachAttributionParams: TrackingMiddleware = () => async event => {
  const qs = querystringToObj();
  const clickIdParams: { [key in ClickIds]?: string } = {};
  Object.values(ClickIds).forEach((id: ClickIds) => {
    const val = qs[id] || TrackingCookies.retrieveClickId(id);
    if (val) {
      clickIdParams[id] = val;
    }
  });
  const conditionalParams = {
    ...clickIdParams,
    embedded_referrer: qs.embedded_referrer,
    template: qs.template,
    utm_campaign: qs.utm_campaign,
    utm_content: qs.utm_content,
    utm_medium: qs.utm_medium,
    utm_source: qs.utm_source,
    ...(!isEmpty(document.referrer) // Remove `referrer` only once Data has deprecated it
      ? {
          referrer: document.referrer,
          http_referer: document.referrer,
        }
      : {}),
  };
  event.apply(conditionalParams);

  event._deprecatedSetProprtiesInRoot([
    ...Object.values(ClickIds),
    'embedded_referrer',
    'template',
    'utm_campaign',
    'utm_content',
    'utm_medium',
    'utm_source',
    'referrer',
  ]);
};

export default attachAttributionParams;
